// removed by extract-text-webpack-plugin
module.exports = {"panel":"_2sjeC5prnfvW_w0CCA1shI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/TrackDetailsStatistics/TrackDetailsStatistics.scss
// module id = 1334
// module chunks = 1